import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../services/AuthService';
import { logoutUser } from '../actions/LoginActions'
import { connect } from 'react-redux'

function AuthenticatedApp(props) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't check authentication on login page or other public pages
    const publicPaths = ['/login', '/nyheder', '/haandvaerkerliste', '/ansogventeliste', '/handelsbetingelser'];
    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path));
    
    if (!isPublicPath) {
      AuthService.checkAuthentication()
        .catch(function (exception) {
          AuthService.logout();
          navigate("/nyheder");
        });
    }
  }, [navigate, location.pathname]);

  const getHeaderItems = () => {
    if (!!props._user) {
      return (
        <div className="Navigation col-md mt-3">
          <Link className="Navigation-link" to="hjem">Hjem</Link>
          <Link className="Navigation-link" to="lejligheder">Lejligheder</Link>
          <Link className="Navigation-link" to="fraflyttere">Fraflyttere</Link>
          <Link className="Navigation-link" to="ventelisteansogninger">Ansøgninger</Link>
          <Link className="Navigation-link" to="venteliste">Venteliste</Link>
          <Link className="Navigation-link" to="opretHaandvaerkerliste">Håndværkerliste</Link>
          <Link className="Navigation-link" to="generalforsamling">Generalforsamling</Link>
          <Link className="Navigation-link" to="varmeregnskab">Varmeregnskab</Link>
          <Link className="Navigation-link" to="opretNyheder">Opret nyheder</Link>
          <Link className="Navigation-link" to="indstillinger">Indstillinger</Link>
          <a className="Navigation-link" href="/nyheder" onClick={() => props.dispatch(logoutUser())}>Log ud</a>
        </div>
      )
    }
    else {
      return (
        <div className="Navigation col-md mt-3">
          <Link className="Navigation-link" to="nyheder">Nyheder</Link>
          <Link className="Navigation-link" to="ansogventeliste">Venteliste</Link>
          <Link className="Navigation-link" to="haandvaerkerliste">Håndværkerliste</Link>
          <Link className="Navigation-link" to="login">Login</Link>
        </div>)
    }
  };

  return (
    <div className="container">
      <div id="header" className="welcomeHeaderDiv">
        <div >
          <h1 className="welcomeHeader">Vanløsegaard</h1>
        </div>
        <div className="menuBarMargin container">{getHeaderItems()}</div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { _user, _jwt } = state.login;
  return { _user, _jwt };
}

export default connect(mapStateToProps)(AuthenticatedApp)